/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Update discount percentage badge on variant change
   * Format: compare-at price (strikethrough) | -XX% | sale price (red)
   */
  var isUpdating = false;

  function updateDiscountPercent(container) {
    if (!container || isUpdating) return;
    isUpdating = true;

    var priceWrappers = container.querySelectorAll('[data-price-wrapper]');
    priceWrappers.forEach(function(wrap) {
      var compareEl = wrap.querySelector('[data-compare-price]');
      var priceEl = wrap.querySelector('[data-product-price]');
      var discountEl = wrap.querySelector('[data-discount-percent]');
      if (!discountEl) return;

      var isOnSale = compareEl && !compareEl.classList.contains('hidden');
      if (isOnSale && priceEl) {
        var selectEl = container.querySelector('[data-product-select]');
        if (!selectEl) { isUpdating = false; return; }

        var variantId = selectEl.value;
        var jsonEl = container.querySelector('[data-product-json]');
        if (!jsonEl) { isUpdating = false; return; }

        try {
          var productData = JSON.parse(jsonEl.innerHTML);
          var variant = productData.variants.find(function(v) {
            return String(v.id) === String(variantId);
          });
          if (variant && variant.compare_at_price && variant.price) {
            var pct = Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            var newText = '-' + pct + '%';
            if (discountEl.innerHTML !== newText) {
              discountEl.innerHTML = newText;
            }
            discountEl.classList.remove('hidden');
          } else {
            discountEl.classList.add('hidden');
          }
        } catch(e) {
          discountEl.classList.add('hidden');
        }
      } else {
        discountEl.classList.add('hidden');
      }
    });

    isUpdating = false;
  }

  // Observe DOM mutations on price wrappers to update discount % on variant change
  var observer = new MutationObserver(function(mutations) {
    if (isUpdating) return;
    var processed = new Set();
    mutations.forEach(function(mutation) {
      // Skip mutations on the discount element itself
      if (mutation.target.hasAttribute && mutation.target.hasAttribute('data-discount-percent')) return;
      if (mutation.target.closest && mutation.target.closest('[data-discount-percent]')) return;

      var wrap = mutation.target.closest ? mutation.target.closest('[data-price-wrapper]') : null;
      if (!wrap) return;
      var container = wrap.closest('[data-product]');
      if (container && !processed.has(container)) {
        processed.add(container);
        updateDiscountPercent(container);
      }
    });
  });

  function initObserver() {
    document.querySelectorAll('[data-price-wrapper]').forEach(function(wrap) {
      observer.observe(wrap, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
